<template>
  <span
    :tabindex="switchTabindex"
    :class="wrapClasses"
    @click="toggle"
    @keydown.space="toggle"
  >
    <input
      type="hidden"
      :name="name"
      :disabled="disabled"
      :value="currentValue"
    />
    <span class="k-switch-inner">
      <slot name="open" v-if="currentValue"></slot>
      <slot name="close" v-if="!currentValue"></slot>
    </span>
  </span>
</template>

<script>
const prefixCls = "k-switch";

export default {
  name: "k-switch",
  props: {
    value: { type: Boolean, default: false },
    name: { type: String },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-checked`]: this.currentValue,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-loading`]: this.loading
        }
      ];
    },
    switchTabindex() {
      return this.disabled || this.loading ? -1 : 0;
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  methods: {
    toggle() {
      event.preventDefault();
      if (this.disabled || this.loading) {
        return false;
      }

      const checked = !this.currentValue;
      this.currentValue = checked;
      this.$emit("input", checked);
      this.$emit("on-change", checked);
    }
  },
  watch: {
    value(val) {
      this.currentValue = val;
    }
  }
};
</script>
